import { CustomModelAutomaticMutationSideEffectConfigs } from "../types";
import { extractRequestFromQueryKey } from "../../../keys";

export const PURCHASES_MUTATION_SIDE_EFFECT_CONFIGS: CustomModelAutomaticMutationSideEffectConfigs<"purchases"> = {
  charge_card_on_file: (request) => ({
    getSome: {
      exact: false,
      predicate: ({ queryKey }) => {
        const queryRequest = extractRequestFromQueryKey(queryKey);
        return queryRequest?.filter?.enduserId ? queryRequest.filter.enduserId === request.enduserId : true;
      },
    },
  }),
};
